import { IconProps } from "../../../../services/utils/types/globals";

CircleCrossIcon.getDefaultProps = {
  size: "16",
  color: "#E84040",
  rotate: "0",
};

export default function CircleCrossIcon(props: IconProps) {
  return (
    <svg
      width={props.size}
      height={props.size}
      // width="16"
      // height="16"
      transform={`rotate(${props.rotate})`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_557_6234)">
        <path
          d="M3.28631 3.28592C0.684158 5.88808 0.684158 10.1119 3.28631 12.714C5.88846 15.3162 10.1122 15.3162 12.7144 12.714C15.3166 10.1119 15.3166 5.88808 12.7144 3.28592C10.1122 0.683771 5.88846 0.683771 3.28631 3.28592ZM10.3574 6.58576L8.94317 7.99997L10.3574 9.41418C10.6167 9.67346 10.6167 10.0977 10.3574 10.357C10.0981 10.6163 9.67384 10.6163 9.41457 10.357L8.00036 8.94278L6.58614 10.357C6.32687 10.6163 5.90261 10.6163 5.64333 10.357C5.38406 10.0977 5.38406 9.67346 5.64333 9.41418L7.05755 7.99997L5.64333 6.58576C5.38406 6.32648 5.38406 5.90222 5.64333 5.64295C5.90261 5.38367 6.32687 5.38367 6.58614 5.64295L8.00036 7.05716L9.41457 5.64295C9.67384 5.38367 10.0981 5.38367 10.3574 5.64295C10.6167 5.90222 10.6167 6.32648 10.3574 6.58576Z"
          fill={props.color}
          // fill="#e84040"
        />
      </g>
      <defs>
        <clipPath id="clip0_557_6234">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
